/*eslint-disable*/
// 表单配置信息
export const collapse = [
    {
        title: '基础信息',
        ref: 'basicForm',
        formName: 'basicInfo',
        col: 4,
        labelWidth: '100px',
        visible: true,
        formList: [
            {
                label: '客户编码',
                prop: 'customerCode',
                value: 'customerCode',
                type: 'custom',
                span: 8,
            },
            {
                label: '客户名称',
                prop: 'customerName',
                value: 'customerName',
                type: 'custom',
                span: 8,
            },
            {
                label: '客户系',
                prop: 'customerGroupName',
                value: 'customerGroupName',
                type: 'custom',
                span: 8,
            },
            {
                label: '内外部',
                prop: 'isGroupCustomer',
                value: 'isGroupCustomer',
                optionsKey: 'SYS_WM_IN_OR_OUT_CUSTOMER',
                type: 'custom',
                span: 8,
            },
            {
                label: '被拜访人',
                prop: 'contact',
                value: 'contact',
                type: 'custom',
                span: 8,
            },
            {
                label: '联系方式',
                prop: 'contactMobile',
                value: 'contactMobile',
                type: 'custom',
                span: 8,
            },
            {
                label: '核心问题',
                prop: 'issues',
                value: 'issues',
                type: 'custom',
                span: 8,
            },
            {
                label: '行业',
                prop: 'typeName',
                value: 'typeName',
                type: 'custom',
                span: 8,
            },
            {
                label: '片区',
                prop: 'areaName',
                value: 'areaName',
                type: 'custom',
                span: 8,
            },
            {
                label: '分公司',
                prop: 'companyName',
                value: 'companyName',
                type: 'custom',
                span: 8,
            },
            {
                label: '经营中心',
                prop: 'businessCenterName',
                value: 'businessCenterName',
                type: 'custom',
                span: 8,
            },
            {
                label: '服务平台',
                prop: 'siteName',
                value: 'siteName',
                type: 'custom',
                span: 8,
            },
            {
                label: '分级分类',
                prop: 'visitLevel',
                value: 'visitLevel',
                optionsKey: 'CUSTOMER_VISIT_LEVEL',
                type: 'custom',
                span: 8,
            },
            {
                label: '拜访开始时间',
                prop: 'visitTimeStart',
                value: 'visitTimeStart',
                type: 'custom',
                span: 8,
            },
            {
                label: '拜访闭环时间',
                prop: 'visitTimeEnd',
                value: 'visitTimeEnd',
                type: 'custom',
                span: 8,
            },
            {
                label: '一级问题分类',
                prop: 'firstClassProblemCode',
                value: 'firstClassProblemCode',
                optionsKey: 'CUSTOMER_FIRST_CLASS_PROBLEM',
                type: 'custom',
                span: 8,
            },
            {
                label: '二级问题分类',
                prop: 'secondClassProblemCode',
                value: 'secondClassProblemCode',
                optionsKey: 'CUSTOMER_SECOND_CLASS_PROBLEM',
                type: 'custom',
                span: 8,
            },
            {
                label: '拜访方式',
                prop: 'visitMode',
                value: 'visitMode',
                optionsKey: 'CUSTOMER_VISIT_MODE',
                type: 'select',
                span: 8,
                rule: [
                    { required: true, message: '拜访方式不能为空', trigger: ['change', 'blur'] }
                ],
            },
            {
                label: '拜访内容记录',
                prop: 'content',
                value: 'content',
                type: 'input',
                sourceType: 'input',
                inputType: 'textarea',
                rows: 3,
                span: 24,
                maxlength: 1000,
                showWordLimit: true,
                rule: [
                    { required: false, message: '拜访内容记录不能为空', trigger: ['change', 'blur'] }
                ],
            },
            {
                label: '附件',
                prop: 'fileList',
                value: 'fileList',
                type: 'custom',
                span: 24,
                rule: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (rule.required && !value.length) {
                                callback(new Error('附件不能为空'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
            },
        ]
    },
];
